import * as React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import ewharter from '../ewharter.jpeg';
import wharter from '../wharter.jpg';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export default function ProductTabs() {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ bgcolor: 'transparent', width: '100vw' }}>
      <AppBar position="static" elevation={0} sx={{ backgroundColor: 'transparent' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
          sx={{ color: '#fff' }}
        >
          <Tab label="Adaptive Threat Landscape Generator (ATLG)" {...a11yProps(0)} sx={{ color: '#fff' }} />
          <Tab label="Universal Data Forge (UDF)" {...a11yProps(1)} sx={{ color: '#fff' }} />
          <Tab label="Resilient Infrastructure Mapper (RIM)" {...a11yProps(2)} sx={{ color: '#fff' }} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} dir={theme.direction}>
        <div style={{ color: '#fff' }}>ATLG is currently in development.</div>
      </TabPanel>
      <TabPanel value={value} index={1} dir={theme.direction}>
        <div style={{ color: '#fff' }}>UDF is currently in development.</div>
      </TabPanel>
      <TabPanel value={value} index={2} dir={theme.direction}>
        <div style={{ color: '#fff' }}>RIM is currently in development.</div>
      </TabPanel>
    </Box>
  );
}